module.exports = __webpack_public_path__ + "resources/img/img_coolfilter5.7fc1007b7b300d45e0f3b6f02c804742.png";